import {Platform, StyleSheet} from 'react-native';
import CommonStyles from '../../utils/CommonStyles';

// Theme-aware styles factory (the makeStyles pattern — docs/DARK-MODE.md):
// consumed via useThemedStyles(makeStyles) so colors re-resolve on theme
// change instead of baking at module load.
const makeStyles = colors =>
  StyleSheet.create({
    mainView: () => ({
      flex: 1,
      backgroundColor: colors.backgroundMuted,
    }),
    marginSet: {
      marginHorizontal: 24,
    },
    buttonContainerStyle: {
      shadowColor: colors.shadow,
      alignItems: 'center',
      shadowOffset: {
        width: 0,
        height: 30,
      },
      shadowOpacity: Platform.OS !== 'web' ? 0.2 : 0,
      shadowRadius: 30,
      elevation: 5,
      marginHorizontal: 16,
      marginBottom: 12,
    },
    buttonStyle: {
      backgroundColor: colors.surface,
      borderRadius: 16,
      alignItems: 'center',
    },
    flexRow: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
    },
    deviceIconWrapper: {
      padding: 4,
    },
    deviceIconContainer: {
      width: 32,
      height: 32,
      borderRadius: 16,
      backgroundColor: colors.backgroundMuted,
      justifyContent: 'center',
      alignItems: 'center',
    },
    deviceIconActive: {
      backgroundColor: colors.accent,
    },
    deviceIconSyncing: {
      backgroundColor: colors.accentStrong,
    },
    menuRow: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginVertical: 24,
    },
    menuLogoAndTitle: {
      flexDirection: 'row',
      alignItems: 'center',
    },
    fullFlex: {
      flex: 1,
    },
    flex1Width292: {
      flex: 1,
      width: 292,
    },
    button: {
      flex: 1,
    },
    webBSHistory: {
      ...CommonStyles.mv_32,
      ...CommonStyles.mh_16,
    },
    // Clears the custom bottom TabBar so the last button (View Blood Sugar History)
    // isn't overlapped and its tap target isn't stolen by the tab bar.
    homeScrollContent: {
      paddingBottom: 120,
    },
  });

export default makeStyles;
